import React from "react";
import PropTypes from "prop-types";

const propTypes = {
  activeClass: PropTypes.string.isRequired,
  children: PropTypes.func.isRequired,
};

class Tabs extends React.Component {
  state = { tab: 1 };
  setTab = tab => {
    this.setState({ tab });
  };
  getClass = tab => {
    return tab === this.state.tab ? this.props.activeClass : "";
  };
  render() {
    const { tab } = this.state;
    return this.props.children({
      tab,
      setTab: this.setTab,
      getClass: this.getClass,
    });
  }
}
Tabs.propTypes = propTypes;
export default Tabs;



// WEBPACK FOOTER //
// ./src/components/ui/Tabs.jsx